import { render, staticRenderFns } from "./AdditionalItem.vue?vue&type=template&id=33b85ce8&scoped=true"
import script from "./AdditionalItem.vue?vue&type=script&lang=js"
export * from "./AdditionalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b85ce8",
  null
  
)

export default component.exports